import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Subscription } from 'rxjs';
import { MessageBox } from './core/message-box';
import { MessageService } from './core/message.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  subscriber: Subscription;
  
  constructor(private message: MessageService, private dialog: MatDialog) {
    this.subscriber = message.getMessage().subscribe(({titulo, message, button}) => {
      MessageBox.show(this.dialog, titulo, 'Mensagem', message, button, true, null, '600px');
    })
  }
}
